"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const RejectSvg = () => (
  <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.99992 14.6668C4.31792 14.6668 1.33325 11.6822 1.33325 8.00016C1.33325 4.31816 4.31792 1.3335 7.99992 1.3335C11.6819 1.3335 14.6666 4.31816 14.6666 8.00016C14.6666 11.6822 11.6819 14.6668 7.99992 14.6668ZM7.99992 13.3335C9.41441 13.3335 10.771 12.7716 11.7712 11.7714C12.7713 10.7712 13.3333 9.41465 13.3333 8.00016C13.3333 6.58567 12.7713 5.22912 11.7712 4.22893C10.771 3.22873 9.41441 2.66683 7.99992 2.66683C6.58543 2.66683 5.22888 3.22873 4.22868 4.22893C3.22849 5.22912 2.66659 6.58567 2.66659 8.00016C2.66659 9.41465 3.22849 10.7712 4.22868 11.7714C5.22888 12.7716 6.58543 13.3335 7.99992 13.3335ZM11.2606 5.68216L5.68192 11.2608C5.3175 11.0012 4.99891 10.6826 4.73925 10.3182L10.3179 4.7395C10.6823 4.99916 11.0009 5.31775 11.2606 5.68216Z" fill="currentColor" />
  </svg>

)

const RejectIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={RejectSvg} {...props} />
);

export default RejectIcon